import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { EditorState, Modifier } from 'draft-js'

import DynamicFieldPicker from './dynamic_field_picker'
import Modal from '../../../../../../Modal'

const buildDynamicFieldsRegex = (dynamicFields) => (
  new RegExp(`\{\{(?:${dynamicFields.join('|')})\}\}`, 'g')
)

const DynamicFieldSpan = (props) => (
  <span
    className="dynamic-field"
    data-offset-key={props.offsetKey}>
    {props.children}
  </span>
)

const InvalidDynamicFieldSpan = (props) => (
  <span
    className="invalid-dynamic-field"
    data-offset-key={props.offsetKey}>
    {props.children}
  </span>
)

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText()
  let match
  while ((match = regex.exec(text)) !== null) {
    callback(match.index, match.index + match[0].length)
  }
}

const dynamicFieldStrategy = dynamicFields => (contentBlock, callback) => {
  const regex = buildDynamicFieldsRegex(dynamicFields)
  findWithRegex(regex, contentBlock, callback)
}

const invalidDynamicFieldStrategy = dynamicFields => (contentBlock, callback) => {
  const regex = buildDynamicFieldsRegex(dynamicFields)
  findWithRegex(regex, contentBlock, (dynStart, dynEnd) => {
    contentBlock.findStyleRanges(
      (charMetaData) => charMetaData.getStyle().size,
      (styleStart, styleEnd) => {
        if (styleStart > dynStart && styleStart < dynEnd) {
          // callback(dynStart, dynStart+2)
          // callback(dynEnd-2, dynEnd)
          callback(dynStart, dynEnd)
        }
        if (styleEnd > dynStart && styleEnd < dynEnd) {
          // callback(dynStart, dynStart+2)
          // callback(dynEnd-2, dynEnd)
          callback(dynStart, dynEnd)
        }
      }
    )
  })
}

export const dynamicFieldDecorators = dynamicFields => ([
  {
    strategy: invalidDynamicFieldStrategy(dynamicFields),
    component: InvalidDynamicFieldSpan,
  },
  {
    strategy: dynamicFieldStrategy(dynamicFields),
    component: DynamicFieldSpan,
  },
])

export default class DynamicField extends Component {
  static propTypes = {
    dynamicFields: PropTypes.arrayOf(PropTypes.string).isRequired,
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {
    open: false
  }

  showDynamicFieldPicker = event => {
    event.preventDefault()
    this.setState({ open: true })
  }

  handleDynamicFieldPick = field => {
    this.setState({ open: false }, () => {
      const { editorState } = this.props
      this.props.onChange(EditorState.push(
        editorState,
        Modifier.replaceText(
          editorState.getCurrentContent(),
          editorState.getSelection(),
          `{{${field}}}`
        )
      ))
    })
  }

  render() {
    return (
      <div className="insert-dynamic-field">
        <div className="control" onMouseDown={this.showDynamicFieldPicker}>
          {'{{…}}'}
        </div>
        <Modal isOpen={this.state.open} onRequestClose={() => this.setState({ open: false })}>
          <DynamicFieldPicker
            dynamicFields={this.props.dynamicFields}
            onPick={this.handleDynamicFieldPick} />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/dynamic_field.js